import React, { useState } from "react";
import Cookies from "js-cookie";
import { setSessionCookie } from "../helpers/session";
import { validatePassword, PASSWORD_MAX } from "../helpers/accountRules";

export default function SettingsWidget({ API_BASE, onClose, onDeleteAccount }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [status, setStatus] = useState("");

  const submit = async () => {
    if (newPw !== confirmPw) return setStatus("New passwords don't match.");
    const check = validatePassword(newPw);
    if (check.error) return setStatus(check.error.replace(/^Password/, "New password"));
    try {
      const res = await fetch(`${API_BASE}/api/change_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session: Cookies.get("session"), old_password: oldPw, new_password: newPw }),
      });
      const data = await res.json();
      setStatus(data.message || data.error);
      if (!data.error) {
        if (data.session) setSessionCookie(data.session); // changing the password signs out every other device; this one gets a fresh session
        setOldPw("");
        setNewPw("");
        setConfirmPw("");
      }
    } catch {
      setStatus("Request failed.");
    }
  };

  return (
    <div className="overlay-widget">
      <h2>Settings</h2>
      <h4>Change password</h4>
      <input type="password" autoComplete="current-password" maxLength={PASSWORD_MAX} placeholder="Current password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} />
      <input type="password" autoComplete="new-password" maxLength={PASSWORD_MAX} placeholder="New password (8+ characters)" value={newPw} onChange={(e) => setNewPw(e.target.value)} />
      <input type="password" autoComplete="new-password" maxLength={PASSWORD_MAX} placeholder="Confirm new password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} />
      <button onClick={submit}>Update password</button>
      {status && <p>{status}</p>}
      <hr />
      <button style={{ background: "darkred", color: "white" }} onClick={onDeleteAccount}>
        Delete account
      </button>
      <button onClick={onClose}>Close</button>
    </div>
  );
}
